// extracted by css-extract-rspack-plugin
export default {"root":"Text-module__root___C3IpM"};